import axios from 'axios';
import {createQuery } from 'react-query-kit';

import { restUrl } from '@/services/utils';

export const useExportFormat = createQuery({
    gcTime: 0,
    queryKey: ['exportFormats'],
    fetcher: async () => {
        const response = await axios.get(restUrl('datamodel/exportFormats?includeExportMappings=false&returnKeyValueFormat=false'));
        return response.data;
    }
});

